import axios from "axios";

import { Workspace } from "../types/workspace";

export const getWorkspace = async (
  workspaceSlug: string,
): Promise<Workspace> => {
  return (await axios.get(`/api/v1/workspaces/${workspaceSlug}`)).data;
};

export interface WorkspaceMemberDetails {
  "user-id": number;
  username: string;
  role: string;
  status: string;
}

export const getWorkspaceMembers = async (
  workspaceSlug: string,
): Promise<WorkspaceMemberDetails[]> => {
  return (await axios.get(`/api/v1/workspaces/${workspaceSlug}/members`)).data;
};

export interface InviteWorkspaceMemberData {
  email: string;
  role: string;
}

export const inviteWorkspaceMember = async (
  workspaceSlug: string,
  data: InviteWorkspaceMemberData,
): Promise<void> => {
  await axios.post(`/api/v1/workspaces/${workspaceSlug}/members`, data);
};

export const joinWorkspace = async (
  workspaceId: number,
  token: string,
): Promise<void> => {
  await axios.post(`/api/v1/workspaces/${workspaceId}/invites/accept`, {
    token,
  });
};

export const updateWorkspace = async (
  workspaceSlug: string,
  workspace: Workspace,
): Promise<void> => {
  await axios.put(`/api/v1/workspaces/${workspaceSlug}`, workspace);
};

export const getScript = async (workspaceSlug: string): Promise<string> => {
  return (await axios.get(`/api/v1/workspaces/${workspaceSlug}/script.js`))
    .data;
};

export const uploadProductMargins = async (
  workspaceSlug: string,
  file: File,
): Promise<void> => {
  const form = new FormData();
  form.append("file", file);
  await axios.put(`/api/v1/workspaces/${workspaceSlug}/products.csv`, form);
};

export interface ParetoAnalysis {
  pareto: number | null;
}

export const getParetoAnalysis = async (
  workspaceSlug: string,
  kind: "visitor" | "customer" = "customer",
): Promise<ParetoAnalysis> => {
  return (
    await axios.get(`/api/v1/workspaces/${workspaceSlug}/pareto`, {
      params: { kind },
    })
  ).data;
};
